module.exports = __webpack_public_path__ + "img/7minutos2.be26afba.jpg";